import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { CONDENSED_FONT } from "fe-web-components/styles/typography";

const themeSettings = require("./clinic/clinicSettings/defaultSettings/theme.json");

export const AskKahunMainTheme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: KahunColorMap.Primary,
        light: KahunColorMap.PrimaryDim,
        dark: KahunColorMap.Default,
      },
      secondary: {
        main: KahunColorMap.Secondary,
        light: KahunColorMap.SecondaryLight,
        dark: KahunColorMap.Accent,
      },
      info: {
        main: KahunColorMap.Secondary,
        light: KahunColorMap.DefaultLight,
        dark: KahunColorMap.Default,
      },
      background: { default: "rgb(255,255,255)" },
    },
    typography: {
      fontFamily: CONDENSED_FONT, // JM: not sure why this is Helvetica here?
      h4: {
        fontSize: "2.0rem",
        fontWeight: 200,
      },
      subtitle1: {
        fontWeight: 200,
      },
      // because MUI does not yet support custom variants or custom theme properties
      // we are taking over the unused 'caption' property to use as 'condensed'
      // There is an open PR to fix this in MUI
      caption: {
        fontFamily: "Roboto Condensed",
        //"Helvetica Neue"
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            ...themeSettings.colors,
          },
        },
      },
    },
  }),
);
